import { CreateExperienceCustomMetricFe } from "@intelligems/ig-types/fe-only/custom-events";
import { useTheme } from "@mui/material";
import { SxProps } from "@mui/system";
import { AnalyticsActiveFilterType } from "@src/store/types/dashboardFilters";

export const SITEWIDE_ANALYTICS_STICKY_HEADER_HEIGHT = 72;

export const getFilterLabel = (
  filter: AnalyticsActiveFilterType,
  customMetrics: CreateExperienceCustomMetricFe[]
) => {
  if (filter.key === "customEvents") {
    if (filter.value.length > 2) {
      let label = "";
      label = filter.value
        .slice(0, 2)
        .map(
          (value: string) =>
            customMetrics.find(
              (metric) => metric.customEvent.identifier === value
            )?.customEvent.name
        )
        .filter(Boolean)
        .join(", ");
      label = label + ` + ${filter.value.length - 2} more`;
      return `Custom Events: ${label}`;
    } else {
      let label = "";
      label = filter.value
        .map(
          (value: string) =>
            customMetrics.find(
              (metric) => metric.customEvent.identifier === value
            )?.customEvent.name
        )
        .filter(Boolean)
        .join(", ");
      return `Custom Events: ${label}`;
    }
  }
  return filter.label;
};

export const getStickyBelowHeaderStyles = (zIndex = 80): SxProps => {
  const theme = useTheme();

  return {
    position: "sticky",
    top: SITEWIDE_ANALYTICS_STICKY_HEADER_HEIGHT,
    left: 0,
    width: "100%",
    paddingY: 4,
    backgroundColor: theme.igBackgroundColors.baseLightMid,
    zIndex,
  };
};
